/* eslint-disable */
export const LockTypeEnum = {
    allow: "0",
    prevent: "1"
}